import { Col, Row, Container, Card, Image, Stack } from "react-bootstrap";
import { Button } from "../../components/Formularios/Buttons/Button";
import Input from "../../components/Formularios/Inputs/Input";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiPost from "../../api/endPoints/usePost";
import { toast } from "react-toastify";
// import logo from "../../assets/img/XC_Helpdesk.jpg";
import logo from "../../assets/img/CodeData.jpg";
import InputSemBorda from "../../components/Formularios/Inputs/InputsSemBorda";
import { Button as ButtonCustom } from "../../components/Formularios/Buttons/Button";
import ApiPut from "../../api/endPoints/usePut";
import { Modal } from "react-bootstrap";
import ValidaComplexidadeSenha from "../../components/Formularios/ValidaComplexidadeSenha";
import { mdiCheckCircle, mdiKeyboardReturn } from "@mdi/js";
import { endpointPrincipal } from "../../api/endPoints/endpointPrincipal/endpointPrincipal";
import { AxiosError } from 'axios';
import { setSessionData } from "../../utils/storageUtils";
import { FUNCAO_PAINEL_TV, PERFIL_PAINEL_TV } from "../../types/PermissaoInterface";

export function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [senha, setSenha] = useState<string>("");
  const emailRef = useRef<HTMLInputElement>(null);
  const senhaRef = useRef<HTMLInputElement>(null);
  //#region ===> VALIDAR LOGIN
  const login = async (email: string, password: string) => {
    const dados = {
      email: email,
      senha: password,
    };

    try {
      const response = await endpointPrincipal.post("/auth/login", dados);
      const { token } = response.data;
      
      // Decodificar o token JWT (payload)
      const payload = JSON.parse(atob(token.split('.')[1]));
      
      // Armazenar dados da sessão (agora no localStorage via storageUtils)
      const perfil =
        payload.funcao === FUNCAO_PAINEL_TV
          ? PERFIL_PAINEL_TV
          : payload.funcao === "Usuario"
            ? "usuario"
            : "agente";

      setSessionData("xc-helpdesk-token", token);
      setSessionData("DadosUsuario", payload.nome_usuario);
      setSessionData("EmailUsuario", payload.email);
      setSessionData("DadosUsuarioID", String(payload.id_usuario));
      setSessionData("PerfilUsuario", perfil);
      setSessionData("isPerfilSuper", payload.funcao === 'Administrador' ? "true" : "false");
      setSessionData("NomeUsuario", payload.nome_usuario);

      if (perfil === PERFIL_PAINEL_TV) {
        localStorage.removeItem("redirectPath");
        window.location.href = "/kpi/dashboard/paineldecontrole";
        return;
      }
      
      // Verificar se há um caminho de redirecionamento salvo diretamente no localStorage
      const redirectPath = localStorage.getItem('redirectPath'); 
      if (redirectPath) {
        localStorage.removeItem('redirectPath'); // Limpar o caminho salvo diretamente do localStorage
        window.location.href = redirectPath; // Redirecionar para o caminho salvo
      } else {
        // Redirecionar para o painel de controle padrão
        window.location.href = '/kpi/dashboard/paineldecontrole'; 
      }
      
    } catch (erro: unknown) {
      const axiosError = erro as AxiosError<{message: string}>;
      const msg = axiosError.response?.data?.message || axiosError.message;
      toast.error(`Falha ao realizar login. Motivo: ${msg}`);
    }
  };

  useEffect(() => {
    // Se SKIP_AUTH estiver ativo, redireciona direto para a página principal
    if (process.env.REACT_APP_SKIP_AUTH === 'true') {
      navigate("/");
    }
  }, []);

  //#endregion
  const enviar = (event: any) => {
    event.preventDefault();
    login(email, senha);
  };

  ///PARTE DE REDEFINIÇÃO DE SENHA///

  //controle modal recSenha
  const [showModalRecSenha, setshowModalRecSenha] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [EmailRec, setEmailRec] = useState("");

  function abrirModalRecSenha() {
    setEmailRec("");
    setIsSubmitting(false);
    setshowModalRecSenha(true);
  }

  async function enviarSolicitacaoRecuperacao(e: React.FormEvent) {
    e.preventDefault();
    
    if (!EmailRec || EmailRec.trim() === "") {
      toast.error("Por favor, insira um email válido");
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const response = await endpointPrincipal.post("/auth/recuperar-senha", {
        email: EmailRec
      });
      
      toast.success("Se o e-mail existir em nosso sistema, você receberá as instruções de recuperação de senha");
      setshowModalRecSenha(false);
    } catch (error) {
      const axiosError = error as AxiosError<{message: string}>;
      
      // Mensagem genérica para não revelar se o email existe
      toast.success("Se o e-mail existir em nosso sistema, você receberá as instruções de recuperação de senha");
    } finally {
      setIsSubmitting(false);
    }
  }

  function fecharModalRecSenha() {
    setshowModalRecSenha(false);
    setEmailRec("");
  }

  return (
    <main className="mt-5">
      <Container>
        <Card>
          <div className="m-4">
            <Row>
              <Col sm={12} md={12} lg={6}>
                <Card
                  className="p-5 d-flex justify-content-center align-items-center"
                  style={{ height: "95%" }}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <Image
                      alt="logo"
                      src={logo}
                      style={{ maxWidth: "120px", maxHeight: "120px", width: "auto", height: "auto", marginRight: "20px" }}
                    />
                    <h2 className="text-black fw-bold mb-0" style={{ fontSize: "1.8rem", letterSpacing: "2px" }}>
                       HELP DESK
                    </h2>
                  </div>
                </Card>
              </Col>
              <Col sm={12} md={12} lg={6}>
                <Card className="p-5 ">
                  <h3 className="text-center text-black">Controle de Acesso</h3>
                  <form onSubmit={enviar}>
                    <Row>
                      <Col sm={12} md={12} lg={12}>
                        <InputSemBorda
                          label="E-mail"
                          name="email"
                          type="email"
                          placeholder="E-mail"
                          value={email || ""}
                          onChange={setEmail}
                          required={true}
                          useRef={emailRef}
                          classNameInputsSemBorda="form-control bordasInferiorInput text-black"
                        />
                        {/* <Input
                          type="email"
                          name="email"
                          value={email}
                          classNameInput="form-control"
                          classNameLabel="form-label"
                          onChange={setEmail}
                          label="Email"
                          required={true}
                          useRef={emailRef}
                        /> */}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={12}>
                        <InputSemBorda
                          label="Senha"
                          name="senha"
                          type="password"
                          placeholder="Senha"
                          value={senha || ""}
                          onChange={setSenha}
                          required={true}
                          useRef={senhaRef}
                          classNameInputsSemBorda="form-control bordasInferiorInput text-black"
                        />
                        {/* <Input
                          type="password"
                          name="senha"
                          value={senha}
                          classNameInput="form-control"
                          classNameLabel="form-label"
                          onChange={setSenha}
                          label="Senha"
                          required={true}
                          useRef={senhaRef}
                        /> */}
                      </Col>
                    </Row>

                    <button
                      type="button"
                      className="btn btn-link"
                      style={{ display: "block", margin: "auto", color: "#246E37" }}
                      onClick={abrirModalRecSenha}
                    >
                      Esqueceu sua senha?
                    </button>

                    <Stack gap={3} className="col-md-5 mx-auto">
                      <Button
                        className="mt-4 rounded-pill"
                        style={{ backgroundColor: "#246E37", borderColor: "#246E37", color: "white" }}
                        type="submit"
                        descricaoBotao="Acessar"
                      />
                    </Stack>
                  </form>
                </Card>
              </Col>
            </Row>
          </div>
          <Card className="rodape-login p-2 mt-3">
            <section className="d-flex justify-content-end">
              <p className="text-light px-3 fs-6">
                Copyright &copy; {new Date().getFullYear()}. Todos os direitos
                reservados XC Soluções.
              </p>
            </section>
          </Card>
        </Card>
      </Container>

      {/*MODAL REC SENHA */}
      <Modal
        show={showModalRecSenha}
        backdrop="static"
        size="lg"
        keyboard={false}
        centered
      >
        <Modal.Header style={{ backgroundColor: "white" }}>
          <Modal.Title>Recuperação de Senha</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ backgroundColor: "white", textAlign: "left" }}>
          <p>
            Informe o e-mail cadastrado no sistema para receber um link de recuperação de senha.
          </p>
          <form onSubmit={enviarSolicitacaoRecuperacao} style={{ textAlign: "left" }}>
            <div
              className="email-rec"
              style={{ display: "inline-block", width: "50%" }}
            >
              <Row>
                <Col sm={12} md={12} lg={12}>
                  <InputSemBorda
                    label="E-mail"
                    name="email"
                    type="email"
                    placeholder="E-mail"
                    value={EmailRec}
                    onChange={setEmailRec}
                    required={true}
                    classNameInputsSemBorda="form-control bordasInferiorInput text-black text-lowercase"
                  />
                </Col>
              </Row>
            </div>

            <hr />
            <div className="d-flex my-2 gap-1 justify-content-between">
              <ButtonCustom
                type="button"
                className="btn btn-light text-danger bg-white border-0"
                descricaoBotao="Cancelar"
                icone={mdiKeyboardReturn}
                onclick={fecharModalRecSenha}
              />

              <ButtonCustom
                type="submit"
                className="btn btn-light text-info-emphasis bg-white border-0"
                descricaoBotao={isSubmitting ? "Enviando..." : "Enviar"}
                icone={mdiCheckCircle}
                disabled={isSubmitting}
              />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </main>
  );
}
